export type Celda = string | number | boolean | null | undefined;

export function celdaCSV(v: Celda): string {
  if (v == null) return '';
  const t = typeof v === 'number' ? (Number.isFinite(v) ? String(v) : '') : String(v);
  return /[",\r\n]/.test(t) || /^\s|\s$/.test(t) ? `"${t.replace(/"/g, '""')}"` : t;
}

/** CSV con coma y CRLF (lo abre bien Excel en es-MX con el BOM). */
export function aCSV(encabezados: string[], filas: Celda[][]): string {
  return [encabezados, ...filas].map((f) => f.map(celdaCSV).join(',')).join('\r\n');
}

export function descargarTexto(nombre: string, contenido: string, tipo = 'text/csv;charset=utf-8') {
  const blob = new Blob(['﻿' + contenido], { type: tipo });
  descargarBlob(nombre, blob);
}

export function descargarBlob(nombre: string, blob: Blob) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}
